import { IMG_1VsnTiiAvu3fBiOHNVbXTY } from '@ecomm/contentful-media'
import { useTranslation } from '@ecomm/i18n'
import { AlarmMomentsTab } from '@ecomm/shared-components/v2/lib/AlarmMoments/AlarmMomentsTab'

export function TabFire() {
  const { t } = useTranslation('alarm-moments')
  const details = [
    {
      icon: 'Siren',
      text: t('detail.smoke-co-siren')
    },
    {
      icon: 'PhoneRinging',
      text: t('detail.smoke-co-app-notification')
    },
    {
      icon: 'HeadsetPerson',
      text: t('detail.smoke-co-agent-update')
    },
    {
      icon: 'EmergencyDispatch',
      text: t('detail.smoke-co-agent-dispatch')
    },
    {
      icon: 'ShieldCheck',
      text: t('detail.smoke-co-agent-no-response')
    }
  ] as const
  return (
    <AlarmMomentsTab
      image={IMG_1VsnTiiAvu3fBiOHNVbXTY}
      details={details}
      theme="dark"
    />
  )
}
